import { render, staticRenderFns } from "./add-VideoModal.vue?vue&type=template&id=f23c07a8&"
import script from "./add-VideoModal.vue?vue&type=script&lang=js&"
export * from "./add-VideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports